import { useIntl } from "react-intl";

import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { IStakingDepositSearchDto, ModuleType, StakingDepositStatus, TokenType } from "@framework/types";
import { FormGrid } from "@dzambalaorg/ui-kit";

interface IStakingDepositSearchFormProps {
  initialValues: Partial<IStakingDepositSearchDto>;
}

export const StakingDepositSearchForm = (props: IStakingDepositSearchFormProps) => {
  const { initialValues } = props;

  const { formatMessage } = useIntl();

  const { stakingDepositStatus, contractIds, deposit, reward } = initialValues;
  const fixedValues = { stakingDepositStatus, contractIds, deposit, reward };

  return (
    <SearchWithFilters initialValues={fixedValues as any}>
      <FormGrid
        columns={[2, 2]}
        containerProps={{ sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }}
      >
        <EntityInput
          name="contractIds"
          controller="contracts"
          multiple
          fetchData={{ contractModule: [ModuleType.STAKING] }}
        />
        <SelectInput name="stakingDepositStatus" options={StakingDepositStatus} multiple />
        <SelectInput
          multiple
          name="deposit.tokenType"
          options={TokenType}
          label={formatMessage({ id: "form.labels.deposit" })}
        />
        <SelectInput
          multiple
          name="reward.tokenType"
          options={TokenType}
          label={formatMessage({ id: "form.labels.reward" })}
        />
      </FormGrid>
    </SearchWithFilters>
  );
};
